(function ($) {

  $(function () {

    if($("#utmdclink_notes").length) {
      $("#utmdclink_notes").height( $("#utmdclink_notes")[0].scrollHeight );
    }

  });

}(jQuery));
